import React from 'react';
import { NavLink } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';

export function SignupView({ emailRef, passwordRef, confirmPasswordRef, usernameRef, onSubmit, errorMessage, back }) {
    return (
        <>
            <div className='w-full h-full flex flex-col items-center justify-center relative'>
                <h1 className='text-3xl mb-8'>Sign up</h1>
                <form className='flex flex-col items-stretch'>
                    <div className='mb-2 flex items-center justify-between'>
                        <label className='mr-4' htmlFor="email-address">Email</label>
                        <input
                            ref={emailRef}
                            className='rounded p-2 text-white'
                            type="email"
                            label="Email address"
                            onChange={() => { }}
                            required
                            placeholder="Email"
                        />
                    </div>

                    <div className='mv-4 mb-2 flex items-center justify-between'>
                        <label className='mr-4' htmlFor="password">Password</label>
                        <input
                            ref={passwordRef}
                            className='rounded p-2 text-white'
                            type="password"
                            label="Create password"
                            onChange={() => { }}
                            required
                            placeholder="Password"
                        />
                    </div>

                    <div className='mv-4 mb-2 flex items-center justify-between'>
                        <label className='mr-4' htmlFor="confirm-password">Confirm Password</label>
                        <input
                            ref={confirmPasswordRef}
                            className='rounded p-2 text-white'
                            type="password"
                            label="Confirm password"
                            onChange={() => { }}
                            required
                            placeholder="Confirm Password"
                        />
                    </div>

                    <div className='mv-4 flex items-center justify-between'>
                        <label className='mr-4' htmlFor="username">Username</label>
                        <input
                            ref={usernameRef}
                            className='rounded p-2 text-white'
                            type="text"
                            label="Username"
                            onChange={() => { }}
                            required
                            placeholder="Username"
                        />
                    </div>

                    <div className='flex items-center justify-between mt-4'>
                        <div className='text-xs mr-4'>
                            Already have an account? {' '} <NavLink className='link-primary' to="/login" >Log in</NavLink>
                        </div>
                    </div>

                    <div className='flex items-center justify-between mt-4'>
                        <button className="btn-secondary py-2" onClick={back}>
                            <IoChevronBack />
                            Back
                        </button>
                        <button className='btn-primary' type="submit" onClick={onSubmit}>Sign up</button>
                    </div>

                    {errorMessage &&
                        <div className='flex items-center justify-center w-full mt-8'>
                            <p className='text-red capitalize'>{errorMessage}</p>
                        </div>
                    }

                </form>
            </div>
        </>
    );
}

export default SignupView;